import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from '@mui/material';
import { useAccount } from '../../contexts/Account';
import eventBus, { eventBusValues } from '../../eventBus';
import { addSurvey, addSurveyQuestion } from '../../services/survey_services';
import ACSnackbar from '../ACSnackbar';

const SurveyPopUp = () => {
  const { accountDetails, currentUserInfo } = useAccount();
  const [open, setOpen] = useState(false);
  const [question, setQuestion] = useState('');
  const [loading, setLoading] = useState(false);
  const [isSnackbarVisible, setIsSnackbarVisible] = useState(false);

  useEffect(() => {
    const handleOpenSurvey = () => {
      setQuestion('');
      setOpen(true);
    };

    eventBus.on(eventBusValues.openCreateSurvey, handleOpenSurvey);
    return () => {
      eventBus.remove(eventBusValues.openCreateSurvey, handleOpenSurvey);
    };
  }, []);

  const handleCancel = () => {
    if (loading) return;
    setQuestion('');
    setOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const survey = await addSurvey({
        COMPANY_ID: accountDetails?.id,
        ADMIN_ID: currentUserInfo?.username,
      });
      await addSurveyQuestion({
        COMPANY_ID: accountDetails?.id,
        SURVEY_ID: survey.data.addSurvey.id,
        BODY: question,
      });
      setQuestion('');
      setOpen(false);
    } catch (error) {
      console.error('Error adding survey question:', error);
      setIsSnackbarVisible(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="xs" fullWidth>
      <DialogTitle fontSize="30px">Create Survey</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Enter your question"
          type="text"
          fullWidth
          multiline
          rows={3}
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          variant="outlined"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} disabled={loading}>
          Cancel
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={loading || !question.trim()}
        >
          Submit
        </Button>
      </DialogActions>
      <ACSnackbar
        onClose={() => setIsSnackbarVisible(false)}
        open={isSnackbarVisible}
        severity="error"
        text="Something went wrong creating the survey."
      />
    </Dialog>
  );
};

export default SurveyPopUp;
